export class Heart {
  constructor(start, anchor) {
    this.x = start.x;
    this.y = start.y;
    this.vx = Math.random()* 6 - 3;
    this.vy = -Math.random()* 15 ;
    this.s = Math.random() * 7 + 2;
    this.gravity = 0.3;
    this.opacity = 1;

    this.element = document.createElement('span');
    this.element.innerText = "🤍";
    this.element.style.fontSize = `${Math.random() * (50 - 2) + 2}px`;
    this.element.style.position = 'absolute';
    this.element.style.top = '0';
    this.element.style.left = '0';
    this.element.style.opacity = `${this.opacity}`;
    this.element.style.transform = `translate(${this.x}px, ${this.y}px)`;
    anchor.appendChild(this.element);
  }

  update() {
    this.x += this.vx;
    this.y += this.vy;
    this.opacity -= 0.008;
    this.element.style.opacity = `${this.opacity}`;
    this.element.style.transform = `translate(${this.x}px, ${this.y}px)`;
    this.vy += this.gravity;

    if (this.opacity <= 0){
      this.element.remove();
      return true;
    }
    return false;

  }

}
